import type { AppManifest, EditorSDK } from '@wix/platform-editor-sdk';
import type { TranslationFunction } from 'i18next';

import {
  shouldAllowInstallingProfileBuilderEditor,
  shouldEnableUnifiedManager,
} from '../../../../../utils/experiments';
import { applicationActions } from '../actions';

type ApplicationActions = NonNullable<AppManifest['pages']>['applicationActions'];

export const getApplicationActions = async (
  editorSDK: EditorSDK,
  t: TranslationFunction,
): Promise<ApplicationActions> => {
  const isBuilderEditor = await editorSDK.info.isBuilderComponentModelSupported('');
  const actions = [
    ...((await shouldEnableUnifiedManager())
      ? [applicationActions.getUnifiedManagerAction(t)]
      : [applicationActions.getAddPageAction(t)]),
    applicationActions.viewSiteMembersAction,
    ...(isBuilderEditor && !(await shouldAllowInstallingProfileBuilderEditor())
      ? []
      : [applicationActions.getOpenMemberPrivacyDashboardAction(t)]),
    // This panel is currently not supported in BuilderEditor
    ...(isBuilderEditor ? [] : [applicationActions.openSignUpSettingsAction]),
    applicationActions.getDeleteMembersAreaAction(t),
  ];

  return { default: actions };
};
